import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/engagement/punya-tithi";

export const Route = createFileRoute("/admin/_engagement/punya-tithi")({
  component: Page,
});
